import {takeLatest, put, call} from 'redux-saga/effects'
import {
  CONFIRM_EMPLOYEE_PAGE_REQUEST,
  CONFIRM_EMPLOYEE_CREATE_EMPLOYEE_ACCOUNT
} from 'actions/confirmEmployee/constants'
import {getEmployee} from 'api/get-employee'
import {initialize, reset} from 'redux-form'
import {confirmEmployeeInvitation} from 'api/confirm-employee'
import {
  setInvitedEmployee,
  isInvalidInvitation
} from 'actions/confirmEmployee'
import * as act from 'actions'
import * as actNotif from 'actions/notifications'
import {browserHistory} from 'react-router'

function * fillFormConfirmEmployee (request) {
  let employee = request
  let form = {
    firstName: employee.first_name,
    lastName: employee.last_name,
    email: employee.email,
    password: '',
    confirmPassword: ''
  }
  yield put(initialize('confirmEmployeeForm', form))
}

export function * pageRequest (request) {
  try {
    yield put(act.showProgressBar())
    const {payload: {params}} = request
    let resEmployee = yield call(getEmployee, {business_id: params.business_id, pending_email: params.pending_email})
    let employee = resEmployee.data.user
    let business = resEmployee.data.business

    yield call(fillFormConfirmEmployee, employee)
    yield put(setInvitedEmployee({business: business, employee: employee}))
  } catch (error) {
    yield put(isInvalidInvitation(true))
    yield put(actNotif.error(error.message))
  } finally {
    yield put(act.hideProgressBar())
  }
}

export function * createEmployeeAccount (request) {
  try {
    yield put(act.showProgressBar())
    let {payload: {data: {business, employee}}} = request
    yield call(confirmEmployeeInvitation, {business: business, employee: employee})
    browserHistory.push('/success-confirm-employee-invitation')
    yield put(actNotif.success('Employee invitation confirmed'))
  } catch (error) {
    yield put(actNotif.error(error.message))
  } finally {
    yield put(reset('confirmEmployeeForm'))
    yield put(act.hideProgressBar())
  }
}

export default function * confirmEmployeeSaga () {
  yield takeLatest(CONFIRM_EMPLOYEE_PAGE_REQUEST, pageRequest)
  yield takeLatest(CONFIRM_EMPLOYEE_CREATE_EMPLOYEE_ACCOUNT, createEmployeeAccount)
}



// WEBPACK FOOTER //
// ./app/sagas/confirmEmployee/index.js